import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { mapShippingMethods } from '../mappers/shipping-methods.js';
import { GET_SHIPPING_METHODS_FOR_CART } from '../operations/queries/get-shipping-methods-for-cart.js';

const useGetShippingMethods = ({ onError , onCompleted  } = {})=>{
    const cartPriceRef = React__default.useRef(0);
    const handleQueryError = React__default.useCallback((error)=>{
        console.error(`Fetch error: [query:shippingMethodsForCart] : `, error);
        onError === null || onError === void 0 ? void 0 : onError({
            reason: 'QUERY',
            error
        });
    }, [
        onError
    ]);
    const handleOnCompleted = React__default.useCallback((responseData)=>{
        if ('shippingMethodsForCart' in responseData) {
            const finalShippingMethods = mapShippingMethods(responseData.shippingMethodsForCart, cartPriceRef.current);
            onCompleted && onCompleted(finalShippingMethods);
        } else {
            onCompleted && onCompleted([]);
        }
    }, [
        onCompleted
    ]);
    const [getShippingMethodForCart, queryState] = useLazyQuery(GET_SHIPPING_METHODS_FOR_CART, {
        onError: handleQueryError,
        onCompleted: handleOnCompleted
    });
    const getShippingMethods = React__default.useCallback((cartId, cartPrice)=>{
        if (!cartId) {
            throw new Error('Need a cartId to load shipping methods.');
        }
        cartPriceRef.current = cartPrice;
        getShippingMethodForCart({
            variables: {
                checkoutId: cartId
            }
        });
    }, [
        getShippingMethodForCart
    ]);
    const queryResults = React__default.useMemo(()=>swcHelpers.objectSpread({}, queryState, {
            data: queryState.data ? mapShippingMethods(queryState.data.shippingMethodsForCart, cartPriceRef.current) : []
        })
    , [
        queryState
    ]);
    return [
        getShippingMethods,
        queryResults
    ];
};

export { useGetShippingMethods };
//# sourceMappingURL=use-get-shipping-methods.js.map
